import ListForm from '../components/ListForm'

const NewPage = () => (
  <>
    <h2 className="f3 fw6 lh-copy mb3 mb4-ns mv0 tracked-light w-100">
      Create a new list
    </h2>

    <div className="lh-copy mb5 mb5-ns mw7 w-100">
      Start by pasting in URLs of full releases or individual tracks from
      Bandcamp, then enter details about your list below.
    </div>

    <ListForm action="create" />
  </>
)

export default NewPage
